import * as React from 'react';
import { Marker } from 'react-map-gl/mapbox';

export const Pointer: React.FC<{ lat: number, lng: number, animate?: boolean }> = ({ lat, lng, animate = false }) => {
  return (
    <Marker
      latitude={lat}
      longitude={lng}
      anchor="center"
    >
      <style>{`
        @keyframes marker-pulse {
          0% {
            transform: scale(1)
          }
          50% {
            transform: scale(0.8);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes marker-color {
          0% { opacity: 1; color: white; }
          25% { opacity: .5; color: white; }
          50% { opacity: 1; }
          75% { opacity: .5; }
          100% { opacity: 1; }
        }
        .pulse.marker-animate {
          animation: marker-color 0.5s ease-in-out forwards,
                     marker-pulse 0.25s ease-in-out forwards;
        }
        .pulse {
          animation: marker-color 1s ease-in-out forwards;
        }
        .crosshair circle {
          filter: drop-shadow(0 0 1px white);
          fill: white
        }
        .crosshair line {
          filter: drop-shadow(0 0 1px white); 
        }
      `}</style>
      <svg
        viewBox="0 0 24 24"
        stroke="currentColor"
        className={`crosshair w-10 h-10 text-black pulse ${animate ? 'marker-animate' : ''}`}
        fill="none"
        strokeWidth=".5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="2"/>
        <line x1="22" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="12" x2="2" y2="12"/>
        <line x1="12" y1="9" x2="12" y2="2"/>
        <line x1="12" y1="22" x2="12" y2="15"/>
      </svg>
    </Marker>
  );
};